import type { Category } from "@/types/category";
import type { FilterItem } from "@/types/filterItem";

export function sortCategories(categories: Category[]) {
  for (let i = 0; i < categories.length; i++) {
    categories[i].categories.sort(compare);
  }
  function compare(a: FilterItem, b: FilterItem) {
    if (a.sorting > -1 || b.sorting > -1) {
      return a.sorting - b.sorting;
    } else {
      return a.title.localeCompare(b.title);
    }
  }
}
